import React, { useMemo, useState } from 'react';
import { Info } from 'lucide-react';
import RequestHoaInfoModal from './RequestHoaInfoModal';

const RequestHoaInfoTrigger = ({ requestHoaInfo = [], className = 'ml-2', iconSize = 16 }) => {
  const [showModal, setShowModal] = useState(false);
  const hasRequestHoaInfo = useMemo(
    () => Array.isArray(requestHoaInfo) && requestHoaInfo.some(h => h?.name),
    [requestHoaInfo]
  );

  if (!hasRequestHoaInfo) return null;

  return (
    <>
      <button
        type="button"
        className={`${className} btn btn-link p-0 d-inline-flex align-items-center text-info border-0 shadow-none`}
        aria-label="View client-requested HOA information"
        onClick={() => setShowModal(true)}
      >
        <Info size={iconSize} />
      </button>
      <RequestHoaInfoModal
        show={showModal}
        onHide={() => setShowModal(false)}
        requestHoaInfo={requestHoaInfo}
      />
    </>
  );
};

export default RequestHoaInfoTrigger;
